/**
 * @generated SignedSource<<536b33894863e4133ff8e6329a5b1564>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnnouncementAttachmentCard_details$data = {
  readonly content: {
    readonly __typename: "File";
    readonly __typename: "File";
    readonly mimeType: string;
    readonly name: string;
    readonly url: URIString;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id: string;
  readonly thumbnail: {
    readonly url: URIString;
  } | null;
  readonly " $fragmentType": "AnnouncementAttachmentCard_details";
};
export type AnnouncementAttachmentCard_details$key = {
  readonly " $data"?: AnnouncementAttachmentCard_details$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementAttachmentCard_details">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnouncementAttachmentCard_details",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Thumbnail",
      "kind": "LinkedField",
      "name": "thumbnail",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mimeType",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "type": "File",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnnouncementAttachment",
  "abstractKey": null
};
})();

(node as any).hash = "8dea8c49edfd150962a66ffaf648f136";

export default node;
